import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const dialogClasses = generateUtilityClasses('AFDialog', [
  'cancelButton'
]);
